export * from './base.model';
export * from './country.model';
export * from './district.model';
export * from './general.model';
export * from './province.model';
export * from './response.model';
export * from './ward.model';
export * from './role.model';
export * from './department.model';
export * from './hub.model';
export * from './user.model';
export * from './hubRouting.model';
export * from './customer.model';
export * from './reason.model';
export * from './ladingSchedule.model';
export * from './service.model';
export * from './transfer.model.';
export * from './size.model';
export * from './areaGroup.model';
export * from './weightGroup.model';
export * from './weight.model';
export * from './formula.model';
export * from './area.model';
export * from './priceList.model';
export * from './priceService.model';
export * from './serviceDVGTPrice.model';
export * from './package.model';
export * from './report.model';
export * from './cod.model';
export * from './serviceDVGT.model';
export * from "./print.model";
export * from "./customerPriceList.model";
export * from "./page.model";
export * from "./modulePage.model";
export * from "./rolePage.model";
export * from "./customerPaymentTo.model";



// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/index.ts